import React, { useContext, useState } from "react";
import { FilterFieldWrapper } from "../wrappers/FilterFieldWrapper";
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from "@mui/material";
import { MapValuationZones } from "./MapValuationZones";
import {
  ComparableFilterType,
  comparableFilterTypeToLabel,
} from "../../helpers/comparableFilters.helpers";
import { ComparablesFiltersContext } from "../ComparablesFilterProvider";
import colors from "common/styles/colors";
import EditIcon from "../../assets/icons/edit.svg";
import { showToastError } from "common/toast/toast";
import { FullScreenDialog } from "../dialogs/FullScreenDialog";
import { useAllValuationZones } from "../../hooks/valuationZones.hooks";

interface ValuationZoneFilterProps {
  onSelect: (selectedZones: string[]) => void;
}

const MAX_ZONES_LENGTH = 70;

const validateZoneSelection = (zones: string[]): boolean => {
  if (zones.join(",").length > MAX_ZONES_LENGTH) {
    showToastError("Pasirinkitas per didelis kiekis vertinimo zonų");
    return false;
  }
  return true;
};

export const ValuationZoneFilter: React.FC<ValuationZoneFilterProps> = ({
  onSelect,
}) => {
  const [isMapOpen, setIsMapOpen] = useState(false);

  const { getAppliedFilter } = useContext(ComparablesFiltersContext);

  const valuationZones = getAppliedFilter?.(ComparableFilterType.ValuationZone)
    ?.values as string[] | undefined;

  const { data: allZones, isLoading: isLoadingZones } = useAllValuationZones();

  const zoneOptions = allZones?.map((zone) => zone.zone_nr) ?? [];

  const handleAutocompleteChange = (selectedZones: string[]) => {
    if (!validateZoneSelection(selectedZones)) {
      return;
    }
    onSelect(selectedZones);
  };

  return (
    <FilterFieldWrapper
      label={
        comparableFilterTypeToLabel[ComparableFilterType.ValuationZone] ?? ""
      }
    >
      <Autocomplete
        multiple
        options={zoneOptions}
        value={valuationZones ?? []}
        loading={isLoadingZones}
        onChange={(_, value) => handleAutocompleteChange(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Ieškoti zonos..."
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {params.InputProps.endAdornment}
                  <InputAdornment position="end">
                    <Tooltip title="Pasirinkti žemėlapyje">
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsMapOpen(true);
                        }}
                        edge="end"
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                </>
              ),
            }}
          />
        )}
      />
      <FullScreenDialog
        title="Pasirinkti verčių zonas žemėlapyje"
        open={isMapOpen}
        onClose={() => setIsMapOpen(false)}
      >
        <MapValuationZones
          initialSelectedZones={valuationZones}
          onSelect={(selectedZones) => {
            if (!validateZoneSelection(selectedZones)) {
              return;
            }
            onSelect(selectedZones);
            setIsMapOpen(false);
          }}
        />
      </FullScreenDialog>
    </FilterFieldWrapper>
  );
};
